if (!window.hasAttachedAddToCartClick) {
        window.hasAttachedAddToCartClick = true;

        // Initialize suppression flag
        window.__suppressCartDrawerOpen = window.__suppressCartDrawerOpen || false;

        // Popup elements
        const popup = document.getElementById('add-to-cart-popup');
        const popupOverlay = popup?.querySelector('.add-to-cart-popup__overlay');
        const popupClose = popup?.querySelector('.add-to-cart-popup__close');
        const popupContinueBtn = document.getElementById('popup-continue-shopping');
        const popupViewCartBtn = document.getElementById('popup-view-cart');
        const popupImage = document.getElementById('popup-product-image');
        const popupTitle = document.getElementById('popup-product-title');
        const popupVariant = document.getElementById('popup-product-variant');
        const popupCollection = document.getElementById('popup-product-collection_name');
        const popupPrice = document.getElementById('popup-product-price');
        const recommendationPopup = document.getElementById('recommended-add-popup');
        const recommendationPopupContent = recommendationPopup?.querySelector('.recommendation-popup__content');
        const recommendationPopupOverlay = recommendationPopup?.querySelector('.recommendation-popup__overlay');
        const recommendationPopupClose = recommendationPopup?.querySelector('.recommendation-popup__close');
        const recommendationPopupBody = document.getElementById('recommendation-popup-body');
        const recommendationPopupSkip = document.getElementById('recommendation-popup-skip');
        const recommendationPopupCheckout = document.getElementById('recommendation-popup-checkout');
        const declineOffer = document.getElementById('decline-offer');

        let pendingCheckoutButton = null;
        window.__skipCheckoutRecommendationPopup = window.__skipCheckoutRecommendationPopup || false;

        if (recommendationPopup) {
          recommendationPopup.addEventListener('click', function(e) {
            e.stopPropagation();
          });
        }

        if (recommendationPopupContent) {
          recommendationPopupContent.addEventListener('click', function(e) {
            e.stopPropagation();
          });
        }

        function parsePriceCents(value) {
        if (typeof value !== 'string') return null;
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? null : parsed;
        }

        function getProductDataFromButton(btn, fallbackData = {}) {
        if (!btn) return { ...fallbackData };
        const priceFromAttr = parsePriceCents(btn.getAttribute('data-price-cents'));
        return {
            product_title: btn.getAttribute('data-product-title') || fallbackData.product_title || '',
            variant_title: btn.getAttribute('data-variant') || fallbackData.variant_title || '',
            collection_name: btn.getAttribute('data-collection') || fallbackData.collection_name || '',
            price_text: btn.getAttribute('data-price') || fallbackData.price_text || '',
            image: btn.getAttribute('data-image') || fallbackData.image || null,
            price: priceFromAttr !== null ? priceFromAttr : (fallbackData.price || 0)
        };
        }

        function isVariantAvailableValue(value) {
          if (typeof value === 'boolean') {
            return value;
          }
          if (value === null || value === undefined) {
            return false;
          }
          return String(value).toLowerCase() === 'true';
        }

        async function hydrateImageFromHandle(btn, variantId, productData) {
        if (!btn || productData.image) {
            return productData;
        }

        const productHandle = btn.getAttribute('data-product-handle');
        if (!productHandle) {
            return productData;
        }

        try {
            const productRes = await fetch(`/products/${productHandle}.js`);
            if (productRes.ok) {
            const product = await productRes.json();
            const variant = product.variants?.find(v => String(v.id) === String(variantId));
            if (variant?.featured_image) {
                productData.image = variant.featured_image;
            } else if (product.featured_image) {
                productData.image = product.featured_image;
            }
            }
        } catch (err) {
            console.warn('Could not fetch product image:', err);
        }

        return productData;
        }

        // Format price helper - uses theme's Currency.formatMoney function
        function formatPrice(cents) {
        // Wait for theme to be available
        if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
            return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
        }
        // Fallback if theme not loaded yet
        const price = (cents / 100).toFixed(2);
        return '$' + price;
        }

        // Show popup function
        function showAddToCartPopup(productData) {
        if (!popup) return;

        // Set product data
        if (popupImage && productData.image) {
            popupImage.src = productData.image;
            popupImage.alt = productData.product_title || '';
        }
        if (popupTitle) {
            popupTitle.textContent = productData.product_title || '';
        }
        if (popupVariant && productData.variant_title) {
            popupTitle.textContent = productData.variant_title;
            popupVariant.style.display = 'none';
        } else if (popupVariant) {
            popupTitle.textContent = productData.product_title || '';
            popupVariant.style.display = 'none';
        }
        if (popupCollection) {
            if (productData.collection_name) {
            popupCollection.textContent = productData.collection_name;
            popupCollection.style.display = 'block';
            } else {
            popupCollection.style.display = 'none';
            }
        }
        if (popupPrice) {
            if (productData.price_text) {
            popupPrice.textContent = productData.price_text;
            } else {
            // Use theme's Currency.formatMoney if available, otherwise use fallback
            // Use innerHTML to support HTML formatting (e.g., superscript for cents)
            if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
                const formattedPrice = window.theme.Currency.formatMoney(productData.price || 0, window.theme.settings.moneyFormat);
                popupPrice.innerHTML = formattedPrice;
            } else {
                // Fallback if theme not loaded yet - try to wait for theme
                setTimeout(function() {
                    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
                        popupPrice.innerHTML = window.theme.Currency.formatMoney(productData.price || 0, window.theme.settings.moneyFormat);
                    } else {
                        popupPrice.textContent = formatPrice(productData.price || 0);
                    }
                }, 100);
                // Show fallback immediately
                popupPrice.textContent = formatPrice(productData.price || 0);
            }
            }
        }

        // Show popup
        popup.style.display = 'block';
        setTimeout(() => {
            popup.classList.add('show');
        }, 10);

        // Prevent body scroll
        document.body.style.overflow = 'hidden';
        }

        // Hide popup function
        function hideAddToCartPopup(openCartAfter) {
        if (!popup) return;
        popup.classList.remove('show');
        setTimeout(function() {
            popup.style.display = 'none';
            document.body.style.overflow = '';
            // Only clear suppression flag if we're not about to open cart drawer
            // This prevents cart from opening accidentally
            if (!openCartAfter) {
                setTimeout(function() {
                    window.__suppressCartDrawerOpen = false;
                }, 100);
            }
        }, 300);
        }

        function showRecommendationPopup(triggerBtn) {
          if (!recommendationPopup) return;
          if (triggerBtn) {
            pendingCheckoutButton = triggerBtn;
          }
          recommendationPopup.style.display = 'block';
          setTimeout(function() {
            recommendationPopup.classList.add('show');
          }, 10);
          document.body.style.overflow = 'hidden';
        }

        function hideRecommendationPopup() {
          if (!recommendationPopup) return;
          recommendationPopup.classList.remove('show');
          setTimeout(function() {
            recommendationPopup.style.display = 'none';
            document.body.style.overflow = '';
          }, 250);
        }

        async function loadCartRecommendationPopupContent() {
          if (!recommendationPopupBody) {
            return false;
          }

          recommendationPopupBody.innerHTML = '<div class="recommendation-popup__loading">Loading recommendations...</div>';

          try {
            const response = await fetch('/cart?view=ajax', {
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              cache: 'no-store'
            });

            if (!response.ok) {
              throw new Error('Failed to load recommendations');
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const checkoutContainer = doc.querySelector('#CheckoutPopupProducts .cart-recommendation-popup-content');

            if (!checkoutContainer) {
              recommendationPopupBody.innerHTML = '<p class="recommendation-popup__error">{{ "general.additional.empty_recomndation" | t | default: "No recommendations found." }}</p>';
              return false;
            }

            recommendationPopupBody.innerHTML = checkoutContainer.innerHTML;
            const productCards = recommendationPopupBody.querySelectorAll('.product-card');
            return productCards.length > 0;
          } catch (error) {
            console.error('Unable to load recommendation popup content', error);
            recommendationPopupBody.innerHTML = `<p class="recommendation-popup__error">${error.message || 'Unable to load recommendations.'}</p>`;
            return false;
          }
        }

        function continueToCheckoutFromPopup() {
          if (!pendingCheckoutButton) {
            hideRecommendationPopup();
            // If no pending button, redirect to checkout directly
            window.location.href = '/checkout';
            return;
          }
          if (recommendationPopupCheckout) {
            recommendationPopupCheckout.classList.add('btn--loading');
            recommendationPopupCheckout.setAttribute('disabled', 'disabled');
          }
          const checkoutBtn = pendingCheckoutButton;
          const form = checkoutBtn.closest('form');
          pendingCheckoutButton = null;
          //hideRecommendationPopup();
          setTimeout(function() {
            window.__skipCheckoutRecommendationPopup = true;
            //setTimeout(function() {
              if (recommendationPopupCheckout) {
                recommendationPopupCheckout.classList.remove('btn--loading');
                recommendationPopupCheckout.removeAttribute('disabled');
              }
            //}, 50);
            // Submit the form directly instead of clicking the button
            
            window.location.href = '/checkout';
            
          }, 260);
        }
        function continueToCheckoutFromPopup1() {
          if (!pendingCheckoutButton) {
            hideRecommendationPopup();
            // If no pending button, redirect to checkout directly
            window.location.href = '/checkout';
            return;
          }
          if (declineOffer) {
            declineOffer.classList.add('btn--loading');
            declineOffer.setAttribute('disabled', 'disabled');
          }
          const checkoutBtn = pendingCheckoutButton;
          const form = checkoutBtn.closest('form');
          pendingCheckoutButton = null;
          //hideRecommendationPopup();
          setTimeout(function() {
            window.__skipCheckoutRecommendationPopup = true;
            
              if (declineOffer) {
                declineOffer.classList.remove('btn--loading');
                declineOffer.removeAttribute('disabled');
              } 
            // Submit the form directly instead of clicking the button
            
            window.location.href = '/checkout';
            
          }, 260);
        }

        // Event listeners for popup
        
        if (popupClose) {
        popupClose.addEventListener('click', hideAddToCartPopup);
        }
        if (popupContinueBtn) {
          popupContinueBtn.addEventListener('click', function() {
            hideAddToCartPopup();
            
          });
        }
        if (popupViewCartBtn) {
        popupViewCartBtn.addEventListener('click', function() {
            // Hide popup but don't clear flag yet (we'll clear it when opening cart)
            hideAddToCartPopup(true);
            // Clear suppression flag and open cart drawer after popup closes
            setTimeout(function() {
                // Clear flag so drawer can open
                window.__suppressCartDrawerOpen = false;
                // Ensure cart is updated before opening
                if (window.theme && window.theme.cartDrawerInstance && window.theme.cartDrawerInstance.cartForm) {
                    window.theme.cartDrawerInstance.cartForm.buildCart();
                }
                // Open cart drawer
                document.dispatchEvent(new CustomEvent('cart:open'));
            }, 350);
        });
        }

        
        if (recommendationPopupClose) {
          recommendationPopupClose.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            pendingCheckoutButton = null;
            hideRecommendationPopup();
          });
        }
        if (recommendationPopupSkip) {
          recommendationPopupSkip.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            pendingCheckoutButton = null;
            hideRecommendationPopup();
          });
        }
        if (recommendationPopupCheckout) {
          recommendationPopupCheckout.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            continueToCheckoutFromPopup();
          });
        }
        if (declineOffer) {
          declineOffer.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            continueToCheckoutFromPopup1();
          });
        }
        

        // Close on ESC key
        document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            if (popup && popup.classList.contains('show')) {
              hideAddToCartPopup();
            }
            if (recommendationPopup && recommendationPopup.classList.contains('show')) {
              pendingCheckoutButton = null;
              hideRecommendationPopup();
            }
        }
        });

        // Intercept checkout button clicks - use capture phase to run before form submission
        document.addEventListener('click', async function(e) {
          const checkoutBtn = e.target.closest('.cart__checkout');
          if (!checkoutBtn) return;

          const form = checkoutBtn.closest('form');
          if (!form || form.dataset.location !== 'cart-drawer') {
            return;
          }

          if (window.__skipCheckoutRecommendationPopup) {
            window.__skipCheckoutRecommendationPopup = false;
            return;
          }

          // Prevent form submission
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const requiresTerms = checkoutBtn.getAttribute('data-terms-required') === 'true';
          if (requiresTerms) {
            const termsCheckbox = form.querySelector('.cart__terms-checkbox');
            if (!termsCheckbox || !termsCheckbox.checked) {
              alert((window.theme && window.theme.strings && window.theme.strings.cartTermsConfirmation) || '{{ "cart.general.terms" | t }}');
              return;
            }
          }

          checkoutBtn.classList.add('btn--loading');
          pendingCheckoutButton = checkoutBtn;

          try {
            const hasRecommendations = await loadCartRecommendationPopupContent();
            checkoutBtn.classList.remove('btn--loading');
            // Always show popup, even if no recommendations
            showRecommendationPopup(checkoutBtn);
          } catch (error) {
            console.error('Unable to intercept checkout for recommendations', error);
            checkoutBtn.classList.remove('btn--loading');
            // Even on error, show popup (it will show error message)
            showRecommendationPopup(checkoutBtn);
          }
        }, true); // Use capture phase

        // Also prevent form submission directly
        document.addEventListener('submit', function(e) {
          const form = e.target;
          if (!form || form.dataset.location !== 'cart-drawer') {
            return;
          }

          const checkoutBtn = form.querySelector('.cart__checkout');
          if (!checkoutBtn) return;

          // If we have a pending checkout button, prevent form submission
          if (pendingCheckoutButton === checkoutBtn && !window.__skipCheckoutRecommendationPopup) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }, true); // Use capture phase

        document.addEventListener('click', async function (e) {
        const btn = e.target.closest('.add-to-cart-variant');
        if (!btn) return;

        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
            console.error('Variant ID not found on button');
            return;
        }

        const buttonProductData = getProductDataFromButton(btn);
        btn.classList.add('btn--loading');


        try {
            const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            }),
            });

            if (!res.ok) throw new Error('Add to cart failed');
            const cartItem = await res.json();

            btn.classList.remove('btn--loading');
            
            // Prepare product data for popup
            const productData = {
            product_title: buttonProductData.product_title || cartItem.product_title || '',
            variant_title: buttonProductData.variant_title || cartItem.variant_title || '',
            price: buttonProductData.price || cartItem.price || 0,
            price_text: buttonProductData.price_text || '',
            collection_name: buttonProductData.collection_name || '',
            image: buttonProductData.image || cartItem.image || null
            };

            // If no image in cart response, try to fetch from product
            await hydrateImageFromHandle(btn, variantId, productData);

        // Set flag to prevent cart drawer from opening automatically
        window.__suppressCartDrawerOpen = true;
        
        // Show popup instead of automatically opening cart drawer
        showAddToCartPopup(productData);
        
        // Dispatch event for cart update (CartDrawer will respect suppression flag)
        // Cart will update but drawer won't open because flag is set
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Failed to add product to cart. Please try again.');
        }
        });

        document.addEventListener('click', async function(e) {
          const btn = e.target.closest('.add_recommended_to_cart');
          if (!btn) return;
          e.preventDefault();
          e.stopPropagation();
          if (btn.classList.contains('btn--loading')) return;
          if (btn.classList.contains('disabled')) {
            return;
          }

          const container = btn.closest(".qtyContainer");
          const qty = container?.querySelector("select.recQty")?.value || 1;

          const variantId = btn.getAttribute('data-variant-id');

          if (!variantId) {
            console.error('Variant ID missing on recommended button');
            return;
          }

          // Find the product card container
          const productCard = btn.closest('.cart-recommendation-popup__card');
          // Check if this is from pairs-wells-with section
          const pairsWellCard = btn.closest('.pairs-well-with .product-card, .pairs-well-with .custom-product-card-item');
          const isPairsWellWith = !!pairsWellCard;
          
          btn.classList.add('btn--loading');

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ id: variantId, quantity: qty })
            });

            if (!res.ok) throw new Error('Add to cart failed');
            const cartItem = await res.json();

            // If it's from pairs-wells-with, show the popup
            if (isPairsWellWith) {
              const buttonProductData = getProductDataFromButton(btn);
              
              // Get variant title from the card
              const titleEl = pairsWellCard.querySelector('.grid-product__title');
              const variantTitle = titleEl ? titleEl.textContent.trim() : '';
              
              // Get price text from the card
              const priceEl = pairsWellCard.querySelector('.grid-product__price');
              const priceText = priceEl ? priceEl.textContent.trim() : '';
              
              // Get collection name from subtitle if available
              const subtitleEl = pairsWellCard.querySelector('.grid-product__subtitle');
              const collectionName = subtitleEl ? subtitleEl.textContent.trim() : '';
              
              // Get image from the card
              const imageEl = pairsWellCard.querySelector('.grid-product__image img, .grid-product__main_image img');
              const imageUrl = imageEl ? imageEl.src : null;
              
              // Prepare product data for popup
              const productData = {
                product_title: buttonProductData.product_title || cartItem.product_title || '',
                variant_title: variantTitle || buttonProductData.variant_title || cartItem.variant_title || '',
                price: buttonProductData.price || cartItem.price || 0,
                price_text: priceText || buttonProductData.price_text || '',
                collection_name: collectionName || buttonProductData.collection_name || '',
                image: imageUrl || buttonProductData.image || cartItem.image || null
              };
              
              // If no image, try to fetch from product
              await hydrateImageFromHandle(btn, variantId, productData);
              
              // Set flag to prevent cart drawer from opening automatically
              window.__suppressCartDrawerOpen = true;
              
              // Show popup instead of automatically opening cart drawer
              showAddToCartPopup(productData);
              
              // Dispatch event for cart update (CartDrawer will respect suppression flag)
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
            } else {
              // Original behavior for cart recommendation popup
              // Add already-in-cart class to the product card after successful add
              if (productCard) {
                productCard.classList.add('already-in-cart');
              }

              if (window.theme && window.theme.cartDrawerInstance && window.theme.cartDrawerInstance.cartForm) {
                window.theme.cartDrawerInstance.cartForm.buildCart();
              } else {
                document.dispatchEvent(new CustomEvent('cart:build'));
              }

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                bubbles: true,
                detail: {
                  product: cartItem,
                  addToCartBtn: btn,
                  triggerCartBuild: false
                }
              }));
            }
          } catch (error) {
            console.error('Error adding recommended product:', error);
            alert('Failed to add product to cart. Please try again.');
          } finally {
            btn.classList.remove('btn--loading');
          }
        }, true);

        document.addEventListener('click', function(e) {
        const mainProductBtn = e.target.closest('.product-single__form .add-to-cart:not(.add-to-cart-variant)');
        if (!mainProductBtn) return;
        window.__suppressCartDrawerOpen = true;
        });

        document.addEventListener('ajaxProduct:added', async function(event) {
        if (!event.detail || !event.detail.addToCartBtn) return;
        const addToCartBtn = event.detail.addToCartBtn;
        if (!addToCartBtn.classList.contains('add-to-cart') || addToCartBtn.classList.contains('add-to-cart-variant')) {
            return;
        }

        const cartItem = event.detail.product || {};
        const productData = getProductDataFromButton(addToCartBtn, {
            product_title: cartItem.product_title || cartItem.title || '',
            variant_title: cartItem.variant_title || '',
            price: cartItem.price || 0,
            image: cartItem.image || null
        });

        await hydrateImageFromHandle(addToCartBtn, cartItem.id || cartItem.variant_id, productData);

        // Show popup
        showAddToCartPopup(productData);
        });

        // Handle color swatch clicks for recommendation product cards
        document.addEventListener('click', async function(e) {
          const swatch = e.target.closest('.recommendation-color-swatch');
          if (!swatch) return;
          
          e.preventDefault();
          e.stopPropagation();
          
          const variantId = swatch.getAttribute('data-variant-id');
          const variantAvailable = isVariantAvailableValue(swatch.getAttribute('data-variant-available'));
          const variantImage = swatch.getAttribute('data-variant-image');
          const productId = swatch.getAttribute('data-product-id');
          const variantTitle = swatch.getAttribute('data-variant-title');
          const variantUrl = swatch.getAttribute('data-variant-url');

          
          if (!variantId || !productId) return;
          
          // Update active state
          const swatchContainer = swatch.closest('.grid-product__colors');
          if (swatchContainer) {
            swatchContainer.querySelectorAll('.recommendation-color-swatch').forEach(s => s.classList.remove('active'));
            swatch.classList.add('active');
            setTimeout(() => {
              swatchContainer.scrollTo({
                left: swatch.offsetLeft - swatchContainer.clientWidth / 2 + swatch.clientWidth / 2,
                behavior: 'smooth'
              });
            }, 100);
          }
          const swatchImage = swatch.getAttribute('data-swatch-image');
          const cardElement = swatch.closest('.custom-product-card-item')?.querySelector('img.swatch-image-replace');

          if (cardElement && swatchImage) {
            cardElement.src = swatchImage;

            if (cardElement.srcset) {
              cardElement.srcset = cardElement.srcset
                .split(',')
                .map((item) => {
                  const size = item.trim().match(/\s(\d+w)$/)?.[1] || '';
                  const width = size.replace('w', '');

                  return width
                    ? `${swatchImage}${swatchImage.includes('?') ? '&' : '?'}width=${width} ${size}`
                    : swatchImage;
                })
                .join(', ');
            }
          }
          
          // Find the add-to-cart button for this product
          const productCard = swatch.closest('.custom-product-card-item');
          if (!productCard) return;
          
          const addToCartBtn = productCard.querySelector('.add_recommended_to_cart');
          if (!addToCartBtn) return;
          
          // Update variant ID
          addToCartBtn.setAttribute('data-variant-id', variantId);
          
          // Update product image if variant has different image
          if (variantImage) {
            const productImage = productCard.querySelector('.grid-product__image img, .grid-product__main_image img');
            if (productImage) {
              productImage.src = variantImage;
              productImage.srcset = variantImage.replace('400x', '200x') + ' 200w, ' + variantImage + ' 400w';
            }
          }
          
          // Fetch variant details to update price
          try {
            const productHandle = addToCartBtn.getAttribute('data-product-handle');
            if (productHandle) {
              const response = await fetch(`/products/${productHandle}.js`);
              if (response.ok) {
                const product = await response.json();
                const matchingVariant = product.variants.find(v => String(v.id) === String(variantId));
                
                if (matchingVariant) {
                  // Update price
                  const priceEl = productCard.querySelector('.grid-product__price');
                  if (priceEl && window.theme && window.theme.Currency) {
                    const priceHtml = window.theme.Currency.formatMoney(matchingVariant.price, window.theme.settings.moneyFormat);
                    if (matchingVariant.compare_at_price > matchingVariant.price) {
                      const comparePrice = window.theme.Currency.formatMoney(matchingVariant.compare_at_price, window.theme.settings.moneyFormat);
                      priceEl.innerHTML = `<span class="grid-product__price--original">${comparePrice}</span> ${priceHtml}`;
                    } else {
                      priceEl.innerHTML = priceHtml;
                    }
                  }
                }
              }
            }
          } catch (error) {
            console.error('Error fetching variant details:', error);
          }
          
          // Update button availability
          if (variantAvailable) {
            addToCartBtn.classList.remove('disabled');
            const originalText = addToCartBtn.getAttribute('data-original-text');
            if (originalText) {
              addToCartBtn.priceHtml = originalText;
            }
          } else {
            addToCartBtn.classList.add('disabled');
            addToCartBtn.textContent = 'Sold Out';
          }

          const titleEl = productCard.querySelector('.grid-product__title');
          if (titleEl && variantTitle) {
            titleEl.textContent = variantTitle;
          }
          const urlEl = productCard.querySelector('.grid-product__link');
          if (urlEl && variantUrl) {
            urlEl.href = variantUrl;
          }
        });

        // Handle dropdown variant selection for checkout popup and recommendation cards
        document.addEventListener('change', function(e) {
          const select = e.target.closest('.checkout-popup-variant-select, .recommendation-variant-select');
          if (!select) return;

          const selectedOption = select.options[select.selectedIndex];
          if (!selectedOption) return;

          const variantId = selectedOption.value;
          if (!variantId) return;

          const variantAvailable = isVariantAvailableValue(selectedOption.dataset.available);
          const variantImage = selectedOption.dataset.image;
          const variantTitle = selectedOption.dataset.variantTitle;
          const variantPrice = parseInt(selectedOption.dataset.price || '0', 10);
          const variantComparePrice = parseInt(selectedOption.dataset.comparePrice || '0', 10);

          const productCard = select.closest('.custom-product-card-item');
          if (!productCard) return;

          const addToCartBtn = productCard.querySelector('.add_recommended_to_cart');
          if (addToCartBtn) {
            addToCartBtn.setAttribute('data-variant-id', variantId);
            if (variantAvailable) {
              addToCartBtn.classList.remove('disabled');
              const originalText = addToCartBtn.getAttribute('data-original-text');
              if (originalText) {
                addToCartBtn.innerHTML = originalText;
              }
            } else {
              addToCartBtn.classList.add('disabled');
              addToCartBtn.textContent = 'Sold Out';
            }
          }

          if (variantImage) {
            const productImage = productCard.querySelector('.grid-product__image img, .grid-product__main_image img, .grid-product__image-mask img');
            if (productImage) {
              productImage.src = variantImage;
              productImage.srcset = `${variantImage.replace('400x', '200x')} 200w, ${variantImage} 400w`;
            }
          }

          const priceEl = productCard.querySelector('.grid-product__price');
          if (priceEl && window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
            const formattedPrice = window.theme.Currency.formatMoney(variantPrice, window.theme.settings.moneyFormat);
            if (variantComparePrice && variantComparePrice > variantPrice) {
              const formattedCompare = window.theme.Currency.formatMoney(variantComparePrice, window.theme.settings.moneyFormat);
              priceEl.innerHTML = `<span class="grid-product__price--original">${formattedCompare}</span> ${formattedPrice}`;
            } else {
              priceEl.innerHTML = formattedPrice;
            }
          }

          const titleEl = productCard.querySelector('.grid-product__title');
          if (titleEl && variantTitle) {
            titleEl.textContent = variantTitle;
          }
        });

    }